const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

class GoogleAnalytics {
  constructor() {
    this.initialized = false;
    this.measurementId = GA_MEASUREMENT_ID;
  }

  init() {
    if (this.initialized || !this.measurementId) return;

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.measurementId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };

    window.gtag("js", new Date());
    window.gtag("config", this.measurementId, {
      send_page_view: false
    });

    this.initialized = true;
  }

  track(eventName, parameters = {}) {
    if (!this.initialized) return;

    window.gtag("event", eventName, {
      ...parameters,
      send_to: this.measurementId
    });
  }

  page(pagePath, pageTitle) {
    if (!this.initialized) return;

    window.gtag("event", "page_view", {
      page_path: pagePath || window.location.pathname,
      page_title: pageTitle || document.title,
      page_location: window.location.href,
      send_to: this.measurementId
    });
  }

  identify(userId, traits = {}) {
    if (!this.initialized) return;

    window.gtag("config", this.measurementId, {
      user_id: userId,
      user_properties: traits
    });
  }
}

export default new GoogleAnalytics();
